import { Routes, CanDeactivate } from '@angular/router';
import { DashboardComponent } from './dashboard';
import { NoContentComponent, UnAuthorizeComponent, ErrorComponent } from './shared/helper-components';
import { DataResolver } from './app.resolver';
import { RoleGuard, AuthGuard, PendingChangesGuard } from './shared/core/index'
import { UserManagementComponent } from './users/user-management.component';
import { SearchComponent } from './search/search.component';
import { ClearanceItemComponent, ClearanceListComponent } from './clearance-item';
import { ClearanceItemHistoryComponent } from './clearance-item/clearance-item-history.component';

import { LoginComponent } from './login/login.component'
import { DocumentDetailComponent } from './docviewer/document-detail.component';

export const ROUTES: Routes = [
  
  { path: '', component: DashboardComponent, pathMatch: 'full', canActivate: [RoleGuard], data: { roles: [process.env.CLEARANCE_ROLE, process.env.PRODUCTION_ROLE] } }, 
  { path: 'access_token', redirectTo: '/dashboard', pathMatch: 'full' }, 
  { path: 'docviewer/:filename/:originalname', component: DocumentDetailComponent },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [RoleGuard], data: { roles: [process.env.CLEARANCE_ROLE, process.env.PRODUCTION_ROLE] },
  },
  {
    path: 'dashboard/:projectId',
    component: DashboardComponent,
    canActivate: [RoleGuard], data: { roles: [process.env.CLEARANCE_ROLE, process.env.PRODUCTION_ROLE] },
  },
  {
    path: 'usermanagement',
    component: UserManagementComponent,
    canActivate: [RoleGuard], data: { roles: [process.env.CLEARANCE_ROLE] },
    canDeactivate: [PendingChangesGuard]
  },
  {
    path: 'search',
    component: SearchComponent,
    canActivate: [RoleGuard],
    data: {
      roles: [process.env.CLEARANCE_ROLE, process.env.PRODUCTION_ROLE],
      key: 'search'
    }
  },
  // {
  //   path: 'search/:projectId/items/:ciId',
  //   component: ClearanceItemComponent,
  //   canActivate: [RoleGuard], data: {
  //     roles: [process.env.CLEARANCE_ROLE, process.env.PRODUCTION_ROLE]
  //   },
  //   canDeactivate: [PendingChangesGuard]
  // },
  // {
  //   path: 'search/:projectId/items/:ciId/history',
  //   component: ClearanceItemHistoryComponent,
  //   canActivate: [RoleGuard], data: {
  //     roles: [process.env.CLEARANCE_ROLE, process.env.PRODUCTION_ROLE]
  //   },
  // },
  { path: '401', component: UnAuthorizeComponent },
  { path: 'error', component: ErrorComponent },
  { path: '**', component: NoContentComponent },
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/app.routes.ts